import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import LiveDashBoardOpsPlannerMap from "./LiveDashBoardOpsPlannerMap";
import { assetLocationToLatLng } from "./MapViewport.helper";
import "./ProjectDetailsMaps.css";
const FALLBACK_MAP_CENTER = { lat: 0, lng: 0 };
const ProjectDetailsMaps = ({ addressDetails = [], addressDirections = [], isRefreshedLayout, selectedAddress, siteCenter, siteOffset, siteTimezone }) => {
    const mapCenter = useMemo(() => {
        const points = addressDetails
            .map((details) => assetLocationToLatLng(details.location))
            .filter((point) => point !== null);
        if (points.length === 0)
            return siteCenter ?? FALLBACK_MAP_CENTER;
        const lats = points.map((point) => point.lat);
        const lngs = points.map((point) => point.lng);
        return {
            lat: (Math.max(...lats) + Math.min(...lats)) / 2,
            lng: (Math.max(...lngs) + Math.min(...lngs)) / 2
        };
    }, [addressDetails, siteCenter]);
    return (_jsx("div", { className: isRefreshedLayout ? "h-full" : undefined, "data-test": "map-section", children: _jsx(LiveDashBoardOpsPlannerMap, { addressDetails: addressDetails, addressDirections: addressDirections, isRefreshedLayout: isRefreshedLayout, mapCenter: mapCenter, selectedAddress: selectedAddress, siteCenter: siteCenter, siteOffset: siteOffset, siteTimezone: siteTimezone }) }));
};
export default ProjectDetailsMaps;
